import { debug } from 'util';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import axios from 'axios';
import { ENDPOINTS, USER_ROLES } from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from '../company.service';
import { Navigation, promise } from 'selenium-webdriver';
import { min } from 'moment';

const utilities = new Utils();

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  menuItems: any;
  userRole: string;
  companyId: string;
  companyService: CompanyService;
  activeRoute: ActivatedRoute;
  router: Router;
  @Input() useClass;
  @Input() showMenu;
  is_eink : boolean;
  miNews: any;
  miBus: any;
  miEinkdevices: any;
  constructor(
    router: Router,
    route: ActivatedRoute,
    companyService: CompanyService,
  ) {

    this.userRole = '';
    this.router = router;
    this.activeRoute = route;
    this.companyService = companyService;
    this.useClass = !this.useClass ? 'sidebar' : this.useClass;
    this.showMenu = !this.showMenu ? 'yes' : this.showMenu;
    this.menuItems = [
      {
        name: 'owners',
        link: 'owners',
        icon: 'fa fa-user',
        allowedRoles: [USER_ROLES.ADMINISTRATOR],
      },
      {
        name: 'companies',
        // Inside the HTML, the link is obtained directy by calling getCompaniesLink()
        link: ( () => {
          return this.getCompaniesLink();
        }) (),
        icon: 'fa fa-list',
        allowedRoles: [USER_ROLES.ADMINISTRATOR, USER_ROLES.BUSINESS_OWNER],
      },
      {
        name: 'control_panel',
        link: 'company/',
        provideCompanyId: true,
        icon: 'fa fa-home',
        allowedRoles: [USER_ROLES.ADMINISTRATOR, USER_ROLES.BUSINESS_OWNER, USER_ROLES.COMPANY_ADMIN, USER_ROLES.COMPANY_EDITOR],
      },
      {
        name: 'users',
        link: 'users/',
        provideCompanyId: true,
        icon: 'fa fa-user',
        allowedRoles: [USER_ROLES.ADMINISTRATOR, USER_ROLES.BUSINESS_OWNER, USER_ROLES.COMPANY_ADMIN],
      },
      {
        name: 'channels',
        link: 'channels/',
        provideCompanyId: true,
        icon: 'fa fa-cog',
        allowedRoles: [USER_ROLES.ADMINISTRATOR, USER_ROLES.BUSINESS_OWNER, USER_ROLES.COMPANY_ADMIN],
      },
      {
        name: 'devices',
        link: 'devices/',
        provideCompanyId: true,
        icon: 'fa fa-cog',
        allowedRoles: [USER_ROLES.ADMINISTRATOR, USER_ROLES.BUSINESS_OWNER, USER_ROLES.COMPANY_ADMIN],
      },
      {
        name: 'manage_devices',
        link: 'device-edit/',
        provideCompanyId: true,
        icon: 'fa fa-cog',
        allowedRoles: [USER_ROLES.ADMINISTRATOR, USER_ROLES.BUSINESS_OWNER, USER_ROLES.COMPANY_ADMIN],
      },
      {
        name: 'media_materials',
        link: 'media/',
        provideCompanyId: true,
        icon: 'fa fa-file-image-o',
        allowedRoles: [
          USER_ROLES.ADMINISTRATOR,
          USER_ROLES.BUSINESS_OWNER,
          USER_ROLES.COMPANY_ADMIN,
          USER_ROLES.COMPANY_EDITOR,
        ],
      },
      {
        name: 'playlist',
        link: 'playlist/',
        provideCompanyId: true,
        icon: 'fa fa-play-circle',
        allowedRoles: [
          USER_ROLES.ADMINISTRATOR,
          USER_ROLES.BUSINESS_OWNER,
          USER_ROLES.COMPANY_ADMIN,
          USER_ROLES.COMPANY_EDITOR,
          USER_ROLES.COMPANY_VIEWER,
        ],
      },
      {
        name: 'calendar',
        link: 'calendar/',
        provideCompanyId: true,
        icon: 'fa fa-play-circle',
        allowedRoles: [
          USER_ROLES.ADMINISTRATOR,
          USER_ROLES.BUSINESS_OWNER,
          USER_ROLES.COMPANY_ADMIN,
          USER_ROLES.COMPANY_EDITOR,
          USER_ROLES.COMPANY_VIEWER,
        ],
      },
      {
        name: 'manage_news',
        link: 'news/',
        provideCompanyId: true,
        icon: 'fa fa-file-image-o',
        allowedRoles: [
          USER_ROLES.ADMINISTRATOR,
          USER_ROLES.LPP_EDITOR,
          USER_ROLES.BUSINESS_OWNER,
          USER_ROLES.COMPANY_ADMIN
        ],
      },
      {
        name: 'manage_bus',
        link: 'bus/',
        provideCompanyId: true,
        icon: 'fa fa-file-image-o',
        allowedRoles: [
          USER_ROLES.ADMINISTRATOR,
          USER_ROLES.BUSINESS_OWNER
        ],
      },
      {
        name: 'einkdevices',
        link: 'einkdevices/',
        provideCompanyId: true,
        icon: 'fa fa-file-image-o',
        allowedRoles: [
          USER_ROLES.ADMINISTRATOR,
          USER_ROLES.BUSINESS_OWNER,
          USER_ROLES.COMPANY_ADMIN
        ],
      },
    ];

  }

  getCompanyIdFromUrl()//in case of administrator login
  {
    let url = this.router.url.toString().split('/');
    let companyId = '';
    if(url.length>2)
    {
      companyId = url[2];
    }
    return companyId;
  }

  ngOnInit() {

    const _self = this;
    axios.get(ENDPOINTS.GET_CURRENT_USER).then(responseUser => {

      const loggedUser = responseUser.data;

      if (loggedUser.company_administrator.length) {
        _self.setCompanyIdInMenuList(loggedUser.company_administrator[0].id);
      }
      _self.userRole = utilities.getUserRole(loggedUser);
      this.miEinkdevices = this.menuItems.find(p=>p.name=="einkdevices");
      this.miBus = this.menuItems.find(p=>p.name=="manage_bus");
      this.miNews =  this.menuItems.find(p=>p.name=="manage_news");


      this.checkEink_Support();
      this.arrangeMenuItems(loggedUser);

      this.router.events.subscribe((path) => {
           if (path instanceof NavigationEnd ) {

              this.checkEink_Support();
              this.arrangeMenuItems(loggedUser);

              this.setCompanyIdInMenuList(this.companyId);

           }
        });
    });

    this.companyService.getCompanyId().subscribe(companyId => {
      _self.setCompanyIdInMenuList(companyId);
    });
  }


  checkEink_Support()
  {
    let companyId = this.getCompanyIdFromUrl();
    this.companyId = companyId;
    //this.setCompanyIdInMenuList(companyId);
    let einkinfo = localStorage.getItem("einkinfo").split(';');
    einkinfo.forEach(element=>{
      if(element.indexOf(companyId)>=0)
      {
        if(element.indexOf('true')>0) this.is_eink = true;
        else this.is_eink = false;
      }
    });

  }

  arrangeMenuItems(loggedUser)
  {


    let newsIndex = this.menuItems.indexOf(this.miNews);
    let busIndex = this.menuItems.indexOf(this.miBus);
    let einkdevicesIndex = this.menuItems.indexOf(this.miEinkdevices);
    if(newsIndex>0 && busIndex>0 && einkdevicesIndex>0)
    {
        this.menuItems.splice(einkdevicesIndex,1);
        this.menuItems.splice(busIndex,1);
        this.menuItems.splice(newsIndex,1);
    }
    else if(newsIndex>0 && einkdevicesIndex>0)
    {
        this.menuItems.splice(einkdevicesIndex,1);
        this.menuItems.splice(newsIndex,1);
    }




    if(this.router.url.toString().indexOf("owners")<0 && this.router.url.toString().indexOf("companies")<0)
    {
      if(this.userRole == "ADMINISTRATOR" && this.is_eink)
      {
        if(this.menuItems.indexOf(this.miNews)<0 && this.menuItems.indexOf(this.miBus)<0 && this.menuItems.indexOf(this.miEinkdevices)<0)
        {
          this.menuItems.push(this.miNews);
          this.menuItems.push(this.miBus);
          this.menuItems.push(this.miEinkdevices);
        }
      }
      if(this.userRole == "BUSINESS_OWNER" && this.is_eink)
      {
        if(this.menuItems.indexOf(this.miNews)<0 && this.menuItems.indexOf(this.miEinkdevices)<0)
        {
          this.menuItems.push(this.miNews);
          this.menuItems.push(this.miEinkdevices);
        }
      }
      if (loggedUser.company_administrator.length > 0)
      {
        if (loggedUser.company_administrator[0].eink_support) {
          if(this.menuItems.indexOf(this.miNews)<0 && this.menuItems.indexOf(this.miBus)<0 && this.menuItems.indexOf(this.miEinkdevices)<0)
          {
            this.menuItems.push(this.miNews);
            this.menuItems.push(this.miBus);
            this.menuItems.push(this.miEinkdevices);
          }
        }
      }
      else if (loggedUser.company_editor.length > 0) {
        if (loggedUser.company_editor[0].eink_support) {
          if(this.menuItems.indexOf(this.miBus)<0 && this.menuItems.indexOf(this.miEinkdevices)<0)
            this.menuItems.push(this.miBus);
            this.menuItems.push(this.miEinkdevices);
        }
      }
      else if (loggedUser.company_viewer.length > 0) {
        if (loggedUser.company_viewer[0].eink_support) {
          if(this.menuItems.indexOf(this.miBus)<0 && this.menuItems.indexOf(this.miEinkdevices)<0)
            this.menuItems.push(this.miBus);
        }
      }
      if(this.userRole=="LPP_EDITOR")
      {
        if(this.menuItems.indexOf(this.miNews)<0)
            this.menuItems.push(this.miNews);
      }
    }
  }

  setCompanyIdInMenuList(companyId) {
    for (const item of this.menuItems) {
      const urlItems = item.link.split('/');
      if (item.provideCompanyId) {
        item.link = urlItems[0] + '/' + companyId;
      }
    }
  }



  getCompaniesLink() : string {

    if( localStorage['businessOwnerId'] ) {
      return 'companies/' + localStorage['businessOwnerId'];
    } else {
      return 'companies/';
    }
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/sidebar/sidebar.component.ts